import type { Control, FieldValues } from "react-hook-form";

import FormSection from "~/components/formElements/FormSection";
import Switch from "~/components/formElements/Switch";

type OrderStatusFormSectionProps<T extends FieldValues> = {
	control: Control<T>;
};

type FormDataType = {
	confirmed: boolean;
};

const OrderStatusFormSection = <T extends FormDataType>({ control }: OrderStatusFormSectionProps<T>) => {
	return (
		<FormSection title="Bestätigt">
			<div className="grid grid-cols-6 gap-x-6 gap-y-2">
				<div className="col-span-6">
					<Switch
						name={"confirmed"}
						control={control}
						labelOn="Ja"
						labelOff="Nein"
						showAllLabels
					/>
				</div>
			</div>
		</FormSection>
	);
};

export default OrderStatusFormSection;
